function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Overlay from '../overlay';
import ConfigProvider from '../config-provider';
import { guid } from '../util';
import Message from './message';
var config = ConfigProvider.config;
var instance;
var timeouts = {};

var Mask = /*#__PURE__*/function (_React$Component) {
  _inherits(Mask, _React$Component);

  var _super = _createSuper(Mask);

  function Mask() {
    var _this;

    _classCallCheck(this, Mask);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: true
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.setState({
        visible: false
      });

      if (!silent) {
        _this.props.onClose && _this.props.onClose();
      }
    });

    return _this;
  }

  _createClass(Mask, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var timeoutId = this.props.timeoutId;

      if (timeoutId in timeouts) {
        var timeout = timeouts[timeoutId];
        clearTimeout(timeout);
        delete timeouts[timeoutId];
      }
    }
  }, {
    key: "render",
    value: function render() {
      /* eslint-disable no-unused-vars */
      var _this$props = this.props,
          prefix = _this$props.prefix,
          type = _this$props.type,
          title = _this$props.title,
          content = _this$props.content,
          align = _this$props.align,
          offset = _this$props.offset,
          hasMask = _this$props.hasMask,
          afterClose = _this$props.afterClose,
          animation = _this$props.animation,
          overlayProps = _this$props.overlayProps,
          timeoutId = _this$props.timeoutId,
          others = _objectWithoutProperties(_this$props, ["prefix", "type", "title", "content", "align", "offset", "hasMask", "afterClose", "animation", "overlayProps", "timeoutId"]);
      /* eslint-enable */


      var visible = this.state.visible;
      return /*#__PURE__*/React.createElement(Overlay, _extends({}, overlayProps, {
        prefix: prefix,
        animation: animation,
        visible: visible,
        align: align,
        offset: offset,
        hasMask: hasMask,
        afterClose: afterClose
      }), /*#__PURE__*/React.createElement(Message, _extends({}, others, {
        prefix: prefix,
        visible: true,
        type: type,
        shape: "toast",
        title: title,
        className: "".concat(prefix, "message-wrapper"),
        onClose: this.handleClose
      }), content));
    }
  }]);

  return Mask;
}(React.Component);

_defineProperty(Mask, "contextTypes", {
  prefix: PropTypes.string
});

_defineProperty(Mask, "propTypes", {
  prefix: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.node,
  content: PropTypes.node,
  align: PropTypes.string,
  offset: PropTypes.array,
  hasMask: PropTypes.bool,
  afterClose: PropTypes.func,
  animation: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  overlayProps: PropTypes.object,
  onClose: PropTypes.func,
  timeoutId: PropTypes.string
});

_defineProperty(Mask, "defaultProps", {
  prefix: 'next-',
  align: 'tc tc',
  offset: [0, 30],
  hasMask: false,
  animation: {
    "in": 'pulse',
    out: 'zoomOut'
  }
});

var NewMask = config(Mask);

var create = function create(props) {
  /* eslint-disable no-unused-vars */
  var duration = props.duration,
      afterClose = props.afterClose,
      others = _objectWithoutProperties(props, ["duration", "afterClose"]);
  /* eslint-enable no-unused-vars */


  var div = document.createElement('div');
  document.body.appendChild(div);

  var closeChain = function closeChain() {
    ReactDOM.unmountComponentAtNode(div);
    document.body.removeChild(div);
    afterClose && afterClose();
  };

  var newContext = ConfigProvider.getContext();
  var mask,
      myRef,
      destroyed = false;

  var destroy = function destroy() {
    var inc = mask && mask.getInstance();
    inc && inc.handleClose(true);
    destroyed = true;
  };

  ReactDOM.render( /*#__PURE__*/React.createElement(ConfigProvider, newContext, /*#__PURE__*/React.createElement(NewMask, _extends({
    afterClose: closeChain
  }, others, {
    ref: function ref(_ref) {
      myRef = _ref;
    }
  }))), div, function () {
    mask = myRef;

    if (mask && destroyed) {
      destroy();
    }
  });
  return {
    component: mask,
    destroy: destroy
  };
};

function handleConfig(config, type) {
  var newConfig = {};

  if (typeof config === 'string' || React.isValidElement(config)) {
    newConfig.title = config;
  } else if (isObject(config)) {
    newConfig = _objectSpread({}, config);
  }

  if (typeof newConfig.duration !== 'number') {
    newConfig.duration = 3000;
  }

  if (type) {
    newConfig.type = type;
  }

  return newConfig;
}

function isObject(obj) {
  return {}.toString.call(obj) === '[object Object]';
}

function open(config, type) {
  close();
  config = handleConfig(config, type);
  var timeoutId = guid();
  instance = create(_objectSpread({}, config, {
    timeoutId: timeoutId
  }));

  if (config.duration > 0) {
    var timeout = setTimeout(close, config.duration);
    timeouts[timeoutId] = timeout;
  }
}

function close() {
  if (instance) {
    instance.destroy();
    instance = null;
  }
}
/**
 * 创建提示弹层
 * @exportName show
 * @param {Object} props 属性对象
 */


function show(config) {
  open(config);
}
/**
 * 关闭提示弹层
 * @exportName hide
 */


function hide() {
  close();
}
/**
 * 创建成功提示弹层
 * @exportName success
 * @param {Object} props 属性对象
 */


function success(config) {
  open(config, 'success');
}
/**
 * 创建警告提示弹层
 * @exportName warning
 * @param {Object} props 属性对象
 */


function warning(config) {
  open(config, 'warning');
}
/**
 * 创建错误提示弹层
 * @exportName error
 * @param {Object} props 属性对象
 */


function error(config) {
  open(config, 'error');
}
/**
 * 创建帮助提示弹层
 * @exportName help
 * @param {Object} props 属性对象
 */


function help(config) {
  open(config, 'help');
}
/**
 * 创建加载中提示弹层
 * @exportName loading
 * @param {Object} props 属性对象
 */


function loading(config) {
  open(config, 'loading');
}
/**
 * 创建通知提示弹层
 * @exportName notice
 * @param {Object} props 属性对象
 */


function notice(config) {
  open(config, 'notice');
}

export default {
  show: show,
  hide: hide,
  success: success,
  warning: warning,
  error: error,
  help: help,
  loading: loading,
  notice: notice
};